import React from 'react';
import { useUserData } from '@/context/UserDataContext';
import { FormSection } from '../../shared/FormSection';
import { SearchableDropdown } from '../../shared/SearchableDropdown';
import { DIETARY_REQUIREMENTS } from '../../shared/constants';

interface DietaryRequirementsProps {
  error?: string;
}

const DietaryRequirements: React.FC<DietaryRequirementsProps> = ({ error }) => {
  const { userData, setUserData } = useUserData();
  const [inputValue, setInputValue] = React.useState('');
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  const handleSelect = (value: string) => {
    setUserData(prev => ({
      ...prev,
      dietaryRequirements: [...(prev.dietaryRequirements || []), value]
    }));
    setInputValue('');
  };

  const handleRemove = (requirement: string) => {
    setUserData(prev => ({
      ...prev,
      dietaryRequirements: (prev.dietaryRequirements || []).filter(r => r !== requirement)
    }));
  };

  return (
    <FormSection
      question="Do you have any dietary requirements or allergies?"
      helperText="Select any dietary requirements or allergies that apply to you. This helps us ensure our recommendations are safe and appropriate for your needs."
      error={error}
    >
      <div className="space-y-4">
        <SearchableDropdown
          inputValue={inputValue}
          setInputValue={setInputValue}
          onSelect={handleSelect}
          categories={DIETARY_REQUIREMENTS}
          placeholder="Search or add dietary requirement..."
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
        />

        {(userData.dietaryRequirements || []).length > 0 && (
          <div className="flex flex-wrap gap-2">
            {userData.dietaryRequirements.map((requirement, index) => (
              <div
                key={index}
                className="bg-primary/10 py-1 px-3 rounded-full flex items-center gap-1 text-sm"
              >
                <span>{requirement}</span>
                <button
                  onClick={() => handleRemove(requirement)}
                  className="hover:text-primary/80"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </FormSection>
  );
};

export default DietaryRequirements; 